module.exports = __webpack_public_path__ + "static/media/Sad.ecb69e85.png";